<ng-template #displayTemplateRef
             let-cellData
             let-rowData="rowData">

  @if (rowData.isFile) {
    <sc-file-download [fileInfo]="rowData.file"
                      [download$]="downloadFileExpr(rowData)">
    </sc-file-download>
  } @else {
    <a [href]="rowData.link"
       target="_blank">
      <i class="fas fa-link mr-2"></i>{{ rowData.link }}
    </a>
  }

</ng-template>